import { RDF_TYPE_IRI } from 'bones/constants/iris';
import { DraftTopExpression } from 'bones/utils/queryBuilder/types';

export const getClassifyClassesByIri = (topExpression: DraftTopExpression) => {
  const classifyClassesByIri: Record<string, Set<string>> = {};
  topExpression.expressions[0]?.expressions[0]?.filters.forEach((filter) => {
    if (
      filter.subject &&
      filter.operator?.iri === RDF_TYPE_IRI &&
      typeof filter.value !== 'string'
    ) {
      const { subject, value } = filter;
      if (!classifyClassesByIri[subject.iri]) {
        classifyClassesByIri[subject.iri] = new Set();
      }
      if (value?.iri) {
        classifyClassesByIri[subject.iri].add(value.iri);
      }
    }
  });
  return classifyClassesByIri;
};
